/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Type of entity that can be referenced by entity properties.
 */
export type EntityType = (typeof EntityType)[keyof typeof EntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntityType = {
  CALENDAR_EVENT: 'CALENDAR_EVENT',
  CALL_RECORD: 'CALL_RECORD',
  CHANNEL: 'CHANNEL',
  CHAT: 'CHAT',
  COMPANY: 'COMPANY',
  DATABASE_ROW: 'DATABASE_ROW',
  CONTACT: 'CONTACT',
  DOCUMENT: 'DOCUMENT',
  INITIATIVE: 'INITIATIVE',
  PROJECT: 'PROJECT',
  TASK: 'TASK',
  THREAD: 'THREAD',
  USER: 'USER',
} as const;
